import { render } from "./RhNotification.vue?vue&type=template&id=c3216750&scoped=true&ts=true"
import script from "./RhNotification.vue?vue&type=script&lang=ts"
export * from "./RhNotification.vue?vue&type=script&lang=ts"

import "./RhNotification.vue?vue&type=style&index=0&id=c3216750&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3216750"]])

export default __exports__